// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-container {
  box-sizing: border-box;
  font-size: 14px;
  min-width: 0;
  margin: 0;
  padding: 5px;
  text-align: left;
  width: 100%;
}

.info-row {
  margin-bottom: 5px;
}

.info-row span {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Info/Info.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".info-container {\n  box-sizing: border-box;\n  font-size: 14px;\n  min-width: 0;\n  margin: 0;\n  padding: 5px;\n  text-align: left;\n  width: 100%;\n}\n\n.info-row {\n  margin-bottom: 5px;\n}\n\n.info-row span {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
